import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";

export const form32 = (record: any) => {
  return {
    departmentCode: "2",
    aflType: AFLType.ApplicationForLeave,
    layout: [
      {
        type: "header",
        value: {
          form: 4,
          department: "PHÒNG/TRUNG TÂM",
        },
      },
      {
        type: "title",
        value: {
          sub: [`(Dành cho Phó trưởng phòng/trung tâm, Cán bộ Đội nghỉ từ 03 ngày trở lên)`],
        },
      },
      {
        type: "salutation",
        value: ["Giám đốc Chi nhánh", "Trưởng phòng/trung tâm"],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTitle)[1],
          },
          {
            type: "eWorkPlace",
            value: StringHelper.verticalBarSplit<string[]>(record?.eUnit)[1],
          },
          {
            type: "",
            value: `Nay tôi làm đơn này kính đề nghị Giám đốc, Trưởng phòng/trung tâm đồng ý giải quyết cho tôi được nghỉ phép năm ${new Date().getFullYear()} lần thứ ${
              record?.ePaidLeaveTimes || ""
            }.`,
          },
          {
            type: "",
            value: `Số lượng phép theo tiêu chuẩn: ${
              record?.ePaidLeaveRemain + "" || ""
            } ngày (trong TH nghỉ phép từ lần thứ 2 trở đi, chỉ ghi rõ số ngày phép còn lại chưa thực hiện).`,
          },

          { type: "eVacationPeriod", value: record?.eVacationPeriods[0] },
          { type: "eLeavePlace", value: record?.eLeavePlace || "" },
          { type: "ePhoneNumber", value: record?.ePhone || "" },
          { type: "eReason", value: record?.eReason },
          {
            type: "",
            value: "Rất mong nhận được sự chấp thuận của Ông Giám đốc, Trưởng phòng/trung tâm.",
          },
          { type: "", value: "Xin trân trọng cảm ơn./." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: ["- Như trên;", "- KHHC (để biết);", "- Lưu: phòng/trung tâm."],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: ["XÁC NHẬN CỦA TRƯỞNG PHÒNG/TRUNG TÂM", record?.eSteps[1][0].name],
          },
        ],
        textBreak: 2,
      },
    ],
  };
};
